module.exports = __webpack_public_path__ + "img/stationID@2x.034e1876.png";